import React  from 'react';
import ListComponentProto from './rating-proto.jsx';


export default function renderListInList(id, props) {
    return <ListComponentProto renderMode="list" id={id} {...props} />;
}